import { useContext, useState } from "react";
import { DataContext } from "../contextData/contextData";

function getNumero() {
  const elm = document.querySelector('#inputCargo');
  if (!elm) { return ''; }

  const texto = elm.options[elm.selectedIndex].text;
  return texto.substr(texto.length - 1, 1).replace(/[A-Z]/g, '');
}

export const useUnidadRolTemporis = () => {
  const [rolTemporis, setRol] = useState(false);

  function setRolTemporis() {
    const resp = getNumero();
    setRol(resp !== '');
  }

  return { rolTemporis, setRolTemporis }
}

export const useReingreso = () => {
  const { reingresa, cambioReingresa } = useContext(DataContext);

  function setReingreso(booleanData) { cambioReingresa(booleanData); }

  return { reingresa, setReingreso }
}